export default {"src":"/_next/static/media/money-wave.bab55a65.svg","height":85,"width":133};